import React from 'react'
import styled from 'styled-components'
import Collapsible from './Collapsible'

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: 1300px;
  margin: auto;
  padding: 0 60px;
  box-sizing: border-box;
  @media (max-width: ${props => props.theme.sizes.tablet}) {
    padding: 0 40px;
  }
  @media (max-width: ${props => props.theme.sizes.mobile}) {
    padding: 0 20px;
  }
`


const Wrapper = styled.div`
.Title {
    font-size: 3.3rem;
    line-height: 4.5rem;
}
 h2 {
color: var(--textTitle);
tab-size: 4;
box-sizing: inherit;
margin: 0;
text-transform: none;
border: none;
background: none;
outline: none;
width: 100%;
text-align: left;
cursor: pointer;
font-size: 2rem;
line-height: 24px;
font-weight: bold;
padding: 24px 0;
position: relative;
    }
p  {
    text-size-adjust: 100%;
    tab-size: 4;
    box-sizing: inherit;
    line-height: 30px;
    }
    ul {
    list-style: none;
    margin: 2rem 0;
    li {
      font-size: 17px;
      position: relative;
      margin-bottom: 24px;
      &:before {
        content: "";
        position: absolute;
        height: 8px;
        width: 2px;
        background: var(--textNormal);
        top: 0.9rem;
        left: -1.5rem;
        z-index: 5;
      }
      &:after {
        content: "";
        background: var(--textNormal);
        position: absolute;
        height: 8px;
        width: 2px;
        top: 0.9rem;
        left: -1.5rem;
        z-index: 5;
        transform: rotate(90deg);
      }
    }
}
`
function Faq() {
    return (
        <Container>
            <Wrapper>
            <h2 className="Title">Konya İnşaat Sıkça Sorulan Sorular</h2>
                <Collapsible trigger="Konya İnşaat Firmaları Satılık Daireler" open="false">
                    <p>
                    Yurt dışında yatırım fırsatı arayan yatırımcılar için Konya bulunmaz bir nimet. Yükselen gayrimenkul fiyatları ve hızlı sirkülasyonu ile parasını hızla katlamak isteyen avrupalı ve ortadoğulu yatırımcılar Ayazsan İnşaat desteği ile çok cazip imkanlarlarla (4+1 Daire, 3+1 Daire, 2+1 Daire, Satılık Villa, Butik Villa) mülk sahibi olmaya devam ediyor. Avrupa’dan gelip bizi bulan müşterilerimiz ile çok yakından ilgilenerek kısa süre çok kazanabileceği bir yatırım fırsatı ile kendilerini Konya'da lüks bir daire sahibi yaptık. Sizde uygun fiyata aileniz için yada yatırım amacıyla bizimle +90 (541) 631 70 13 no’lu telefon numaramızdan ulaşabilirsiniz.
                    <br /><br />
                    Konut ve İnşaat'a devam ediyoruz. Konya'da en çok değer kazanan yatırım inşaat yatırımı. Hızla artan gayrimenkul fiyatları ile sermayesini hızlı biçimde arttırmak isteyen yabancı yatırımcılar, ülkemizi sıkça ziyaret ediyor. Biz de Ayazsan İnşaat olarak onlara kültürümüzü, tarihimizi ve Konya'nın göz dolduran güzelliğini anlatırken, cazip imkanlar ile mülk sahibi yapıyoruz. Daha önce bizden konut satın almış bir müşterimizin tavsiyesi üzerine bizimle tanışmak için gelen müşterimiz, Ayazsan İnşaat’ın cazip fiyatlarından, sunmuş olduğu fırsatlardan ve göstermiş olduğu ilgiden memnun kalarak, Konya / Meram'da hızla değer kazanan bir yatırımın sahibi oldu. Siz de uygun fiyatlar ve Ayazsan İnşaat güvencesi ile güçlü bir yatırımın ve aileniz için sıcak bir yuvanın sahibi olabilirsiniz.
                    <br /><br />
                    Konya inşaat şirketleri, konya inşaat projeleri, konya inşaat firmaları listesi, Ayazsan inşaat meram konya, konya büyük inşaat firmaları, Yazır inşaat, Selçuklu konya satılık daire, Konya lüks satılık villa, Ayazsan satılık daire, Ayazsan satılık daireler konya.</p>
                </Collapsible>
                <Collapsible trigger="Konya Selçuklu İnşaat Projeleri">
                    <p>Konya'nın yükselen değerlerinden biri olmaya devam eden Selçuklu, 2.056 kilometrekare yüzölçümüne sahip. Konya'nın batısında bulunuyor; güneyinde Karatay, doğusunda Meram ilçeleri tarafından çevrili.
                    <br /><br />
                    Geniş caddeleri, yeşil alanları ve düzenli yapısıyla Konya'nın en planlı kentleşmiş ilçesi olan ve gecekondu yapılaşması barındırmayan Selçuklu'da birçok toplu konut ve lüks site göze çarpıyor.
                    <br /><br />
                    İlk göç dalgasını eski ve çürük yapılardan kaçan Konyalı vatandaşlar tarafından alan Selçuklu üniversitelerin çoğalması ile beraber ikinci bir göç dalgası yaşamaya başladı.
                    <br /><br />
                    Tramvay yanı sıra bölge için bir otobüs ve ayrıca bir raylı sistem hattı planlanıyor. Önümüzdeki yıllarda hizmete açılması düşünülen metro hattı Yazır'dam Zafer Merkez tarafına olan yolculuğu 17,5 dakikaya düşürecek.
                    <br /><br />
                    Popülerliği gün geçtikçe artan Selçuklu, ulaşım yatırımlarının yanı sıra nitelikli konut yatırımlarının da etkisiyle bir çekim merkezi haline geldi. Konya'nın en fazla prim potansiyeline sahip ilçeleri arasında başı çeken Selçuklu'da mevcutta Ayazsan İnşaat gibi sektörünün önde gelen firmalarının lüks konut projeleri yer alıyor.
                    <br /><br />
                    Selçuklu Konut (Ev) Satış Fiyatları:
                    100 metrekare genişliğinde 2+1 bir daire baz alındığında konut satış fiyatlarının Selçuklu'da, geçtiğimiz 12 yılda %216 arttığı görülüyor.
                    <br /><br />
                    2003'de 65 bin TL olan ölçüt daire, 2008 yılında 100 bin TL seviyesinde ulaşmış; 2009'da yaşanan kısmi bir düşüle 83 bin TL'ye gerilemiş ve 2016 yılının ilk çeyreğine kadar sürekli yükselerek 208 bin TL seviyesine ulaşmıştır.
                    <br /><br />
                    Selçuklu Konut (Kira) Fiyatları:
                    100 metrekare genişliğinde 2+1 bir daire ölçüt alındığında Selçuklu için konut kira fiyatlarının geçtiğimiz 12 yılda %310 oranında bir artış kaydettiği görülüyor.
                    <br /><br />
                    2003'de 242 TL olan ölçüt konut kirası, 2008 yılında 580 TL'ye ulaşmış; 2009 ve 2010 yıllarında yaşanan kısmi düşüşle 420 TL'ye gerilemiş ve 2016'nın ilk çeyreğine kadar sürekli yükselen bir ivme kaydederek 1015 TL'ye ulaşmıştır.
                    <br /><br />
                    Selçuklu Yatırım Geri Dönüş (Amortisman) Süresi:
                    100 metrekare genişliğinde 2+1 bir daire ölçüt alındığınd Selçuklu için konut yatırım geri dönüş (amortisman) süresinin 17 yıl olduğu belirlenmiştir.
                    <br /><br />
                    Selçuklu'daki Önemli Hastaneler:
                    Beyhekim Eğitim ve Araştırma Hastanesi, Konya Ağız ve Diş Sağlığı merkezi, Özel Medova Hastanesi, Selçuk Üniversitesi Tıp Fakültesi Hastanesi, Konya Numune Hastanesi, Başkent Üniversitesi Konya Hastanesi, Medicana Konya Hastanesi, Konyagöz Hastanesi Selçuklu'da bulunan başlıca hastaneleri oluşturuyor.
                    <br /><br />
                    Selçuklu'daki Önemli Okullar:
                    TED KONYA KOLEJİ ÖZEL İLKOKULU, Selçuk Üniversitesi, Konya Teknik Üniversitesi, Selçuk Üniversitesi Güzel Sanatlar Fakültesi, Selçuk Üniversitesi İktisadi ve İdari Bilimler Fakültesi, Selçuk Üniversitesi Hukuk Fakültesi, Selçuk Üniversitesi Alaeddin Keykubat Kampüsü, Konya Teknik Üniversitesi, Selçuk Üniversitesi İletişim Fakültesi, Selçuk Üniversitesi Kampüsü, Şükriye Onsun İLKOKULU,   ÖZEL TÜR-MAK İLKOKULU, ÖZEL KONYA SİSTEM İLKOKULU, ÖZEL KONYA ESENTEPE İLKOKULU, ÖZEL KONYA DOĞA İLKOKULU, ÖZEL FORMKAMPÜS İLKOKULU, ÖZEL DİLTAŞ İLKOKULU,   ZELİHA VE LÜTFİ KULLUK İLKOKULU Selçuklu'da bulunan başlıca okullar.
                    <br /><br />
                    Selçuklu'daki Önemli Alışveriş Merkezleri:
                    M1 Tepe, Real AVM, Selçuker Mall, Novaland AVM, Migros AVM, Çelikkayalar AVM Selçuklu'da başlıca alışveriş merkezleri.
                    <br /><br />
                    Selçuklu Ulaşım Olanakları:
                    Tramvay hattının hizmete açılmasıyla ulaşımı iyice rahatlayan Selçuklu'da 24 saat toplu taşıma imkanı bulunmakta olup Bosna Hersek'den Karatay'a tramvay ile 1 saatte ulaşım sağlanabilmektedir.
                    <br /><br />
                    Öte yandan yakın gelecekte Konya Metrosu'nun temelinin atılmasının planlandığı Ulaştırma Bakanlığınca duyurulmuştur. Bu raylı sistem hattı sayesinde ilçede ulaşımın hayli kolaylaşacağı kesin bir gerçek olarak kabul ediliyor.
                    <br /><br />
                    Son olarak Konya Havalimanı'na yalnızca 13 kilometre uzaklıkta bulunuyor.
                    <br /><br />
                    Selçuklu Yatırım İçin Uygun Mu?
                    Yükselmeye devam eden değeri, topladığı ilginin artmaya devam etmesi, düzenli kentleşmesi ve yakın zamanda devreye girecek yeni ulaşım olanakları göz önüne alındığında Selçuklu'nun yatırım için uygun olduğu görülüyor."</p>
                </Collapsible>
                <Collapsible trigger="Konya İnşaat Firmaları">
                    <p>İnşaat sektöründe orta ve büyük ölçekli projelerin geliştirilmesi, ülkemize yeni inşaat teknolojilerinin getirilmesi ve teknolojideki son yenilikleri takip ederek inşaat sektörümüzün çağdaş düzeye ulaşmasına katkı sunmak amacıyla Konya'da kurulmuş olan Ayazsan İnşaat, kuruluşundan beri süregelen profesyonellik, yaratıcılık, dürüstlük ve pazarı geliştirme özellikleriyle istikrarlı bir büyüme göstererek inşaat dünyasında saygın bir yer edinmiştir.
                    <br /><br />
                    Sektördeki gelişmeleri ve pazardaki yeni talepleri yakından takip eden firma yönetimi, güçlü idari ve mali birikimi ile sektörde öncü firmalardan biri olmayı sürdürmektedir. Büyük mühendislik projelerini hayata geçirmeye devam eden firmamız kurulduğundan itibaren Konya'nın her bölgesinde; Ahırlı, Akören, Akşehir, Altınekin, Beyşehir, Bozkır, Cihanbeyli, Çeltik, Çumra, Derbent, Derebucak, Doğanhisar, Emirgazi, Ereğli, Güneysınır, Hadim, Halkapınar, Hüyük, Ilgın, Kadınhanı, Karapınar, Karatay, Kulu, Meram, Sarayönü, Selçuklu, Seydişehir, Taşkent, Tuzlukçu, Yalıhüyük ve Yunak öncü ve örnek nitelikte, kaliteli, yenilikçi birçok projeye imzasını atmıştır.
                    <br /><br />
                    Üstlendiği taahhütleri zamanında ve beklenen kalite seviyelerinin üzerinde tamamlayarak sektöründe ciddi bir saygınlığa ulaşmış olan İzka İnşaat’ın bugünkü konumuna gelmesinde, personelinin deneyim ve profesyonelliği ile yönetim kadrosunun geliştirmiş olduğu strateji ve organizasyonel başarısı etkili olmuştur.
                    <br /><br />
                    Ayazsan İnşaat tüm taahhüt ve yatırım projelerinde modern yönetim teknikleri kullanmayı, piyasada kendini kanıtlamış, kalitesi belgelenmiş malzeme ve işçiliği tercih ederek projelerini zamanında tamamlamayı temel politikası olarak benimsemektedir.
                    </p>
                </Collapsible>
            </Wrapper>
            </Container>
    )
}

export default Faq
